export default "__VITE_ASSET__GszXoOzD__"